import useSWR from 'swr';

import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';

import { useGetEnterpriseActionsMessages } from './messages';

export function getEnterpriseActionsCacheKey(
  enterpriseId: number | null | undefined,
) {
  return `/api/EnterpriseAction/${enterpriseId}`;
}

export interface useGetEnterpriseActionsOptions {
  shouldFetch?: boolean;
}

export function useGetEnterpriseActions(
  enterpriseId: number | null | undefined,
  options?: useGetEnterpriseActionsOptions,
) {
  const mergedOptions: useGetEnterpriseActionsOptions = {
    shouldFetch: true,
    ...options,
  };

  const { enterpriseActionApi } = usePrivate();

  const results = useSWR(
    enterpriseActionApi && mergedOptions.shouldFetch
      ? getEnterpriseActionsCacheKey(enterpriseId)
      : null,
    () => enterpriseActionApi?.apiEnterpriseActionGet(enterpriseId!),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetEnterpriseActionsMessages[
            'useGetEnterpriseActions.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetEnterpriseActions> error fetching enterprise actions.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !enterpriseActionApi;

  return { ...results, isLoadingOrValidating };
}
